var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2549 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2549 10.7452 48 24 48Z",
    fill: "url(#paint0_linear_64_390)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6426 36.3873L13.4151 29.7604C12.408 27.9475 11.8843 25.9131 11.8843 23.8485C11.8843 17.1007 17.3732 11.6118 24.121 11.6118C30.8688 11.6118 36.3576 17.1007 36.3576 23.8485C36.3576 30.5963 30.8688 36.0852 24.121 36.0852C22.0966 36.0852 20.0924 35.5715 18.2997 34.6047L11.6426 36.3873ZM18.6321 32.1171L19.0551 32.3689C20.596 33.2854 22.3484 33.7688 24.121 33.7688C29.5897 33.7688 34.0412 29.3173 34.0412 23.8485C34.0412 18.3798 29.5897 13.9282 24.121 13.9282C18.6522 13.9282 14.2007 18.3798 14.2007 23.8485C14.2007 25.6513 14.7043 27.4339 15.651 28.995L15.9128 29.418L14.9258 33.1141L18.6321 32.1171Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6731 25.5507C28.1695 25.2486 27.5149 24.9163 26.9207 25.158C26.4674 25.3393 26.1754 26.0543 25.8833 26.4169C25.7322 26.6083 25.551 26.6284 25.3193 26.5378C23.6072 25.8529 22.2979 24.7148 21.3613 23.1437C21.2001 22.902 21.2303 22.7106 21.4217 22.479C21.7037 22.1466 22.0663 21.7639 22.1368 21.3107C22.2173 20.8575 22.0058 20.3338 21.8145 19.931C21.5728 19.4173 21.3109 18.6821 20.7973 18.39C20.3239 18.1181 19.6995 18.2692 19.2765 18.6116C18.5514 19.2058 18.1989 20.1324 18.209 21.0589C18.209 21.3208 18.2392 21.5827 18.3097 21.8345C18.4607 22.4387 18.7327 23.0128 19.0549 23.5466C19.2967 23.9494 19.5484 24.3523 19.8304 24.7249C20.7469 25.9637 21.885 27.0413 23.1943 27.8571C23.8489 28.2599 24.564 28.6125 25.2992 28.8542C26.125 29.1261 26.8602 29.4081 27.7465 29.2369C28.6731 29.0556 29.5896 28.4815 29.9622 27.5852C30.073 27.3233 30.1233 27.0212 30.0629 26.7392C29.932 26.1752 29.1464 25.8227 28.6731 25.5507Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_390",
    x1: 7.02939,
    y1: 7.02416,
    x2: 40.9726,
    y2: 40.9674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B25B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.6f4b7acf71a7bad46cd48c1455a66b76.svg";
export { ForwardRef as ReactComponent };